import React from 'react';
import { Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import styles from './Topbar.module.css';

export default function Topbar({ breadcrumb, locationLabel }) {
  const { instance, accounts } = useMsal();
  const user = accounts[0];

  return (
    <header className={styles.topbar}>
      <div className={styles.brand}>
        <Link to="/" className={styles.mark}>
          <span className={styles.dot} aria-hidden />
          <span className={styles.wordmark}>Lumen</span>
          <span className={styles.sub}>by UnityMSK</span>
        </Link>
        {breadcrumb ? <span className={styles.breadcrumb}>{breadcrumb}</span> : null}
      </div>
      <div className={styles.right}>
        {locationLabel ? <span className={styles.location}>{locationLabel}</span> : null}
        {user ? (
          <button className={styles.user}
                  title={user.username}
                  onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin })}>
            {(user.name || user.username || '?').split(' ').map(s => s[0]).join('').slice(0, 2).toUpperCase()}
          </button>
        ) : null}
      </div>
    </header>
  );
}
